export default __webpack_public_path__ + "static/media/Honored Girdle of the Four Winds.1e03dbfc.jpg";